import { toast } from "react-toastify";

import { settingsSliceActions } from "@/store/slices/settings";

import { nextCargoApi } from "../../baseApi";
import { SettingsCompany } from "./settings.types";

export const settingsApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    getSettingsByCompany: build.query<SettingsCompany["raw"], SettingsCompany["args"], SettingsCompany["response"]>({
      query: ({ id }) => `/settings/company/${id}`,
      onQueryStarted: async (args, { queryFulfilled }) => {
        localStorage.setItem("@enableTolerance", "false");
        try {
          const { data } = await queryFulfilled;
          localStorage.setItem("@enableTolerance", JSON.stringify(data?.enableTolerance));
          settingsSliceActions.setSettings(data);
        } catch {
          // Ignore catch
        }
      },
      transformResponse: (response) => {
        return { ...response, $toleranceQueueIds: [] };
      }
    }),
    toggleSettingsTolerance: build.mutation<void, { company: number; tolerance: boolean }>({
      query: (body) => ({
        url: "/settings/toggle-tolerance",
        method: "POST",
        body: {
          ...body,
          company: String(body.company)
        }
      }),
      onQueryStarted: (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          pending: "Iniciando tolerância...",
          success: "Tolerância ativada com sucesso!",
          error: "Erro ao ativar tolerância"
        });
      }
    })
  })
});

settingsApi.enhanceEndpoints({
  endpoints: {
    getSettingsByCompany: {
      providesTags: ["Settings", "SettingsByCompany"]
    },
    toggleSettingsTolerance: {
      invalidatesTags: ["Settings", "SettingsByCompany", "SyncExpedition"]
    }
  }
});
